import * as React from "react"
import { cn } from "../../lib/utils"

const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: "dashboard" },
  { key: "guilds", label: "Guilds", icon: "dns" },
  { key: "templates", label: "Templates", icon: "layers" },
] as const

type NavItemKey = (typeof NAV_ITEMS)[number]["key"]

interface SidebarProps {
  activeItem: NavItemKey
  onNavigate: (item: string) => void
  disabledItems?: Set<string>
  guildName?: string | null
  className?: string
}

function Sidebar({ activeItem, onNavigate, disabledItems, guildName, className }: SidebarProps) {
  return (
    <aside
      className={cn(
        "fixed left-0 top-0 h-full flex-col py-6 bg-surface-container-low w-64 z-50 hidden md:flex",
        className,
      )}
    >
      {/* Brand */}
      <div className="px-6 mb-8">
        <div className="text-xl font-bold text-on-surface tracking-tighter">
          Role Bot
        </div>
        {guildName && (
          <div className="flex items-center gap-1.5 mt-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-success inline-block flex-shrink-0" />
            <span className="text-[11px] text-on-surface-variant truncate">{guildName}</span>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1">
        {NAV_ITEMS.map((item) => {
          const isActive = activeItem === item.key
          const isDisabled = disabledItems?.has(item.key)
          return (
            <button
              key={item.key}
              onClick={() => !isDisabled && onNavigate(item.key)}
              disabled={isDisabled}
              className={cn(
                "flex items-center gap-3 w-full px-6 py-2.5 text-sm font-medium transition-all duration-150",
                isDisabled
                  ? "text-on-surface-variant/40 cursor-not-allowed"
                  : isActive
                    ? "bg-primary text-primary-foreground cursor-pointer"
                    : "text-on-surface-variant hover:bg-surface-container-high cursor-pointer",
              )}
            >
              <span className="material-symbols-outlined text-[20px]">
                {item.icon}
              </span>
              {item.label}
            </button>
          )
        })}
      </nav>

      {/* Footer */}
      <div className="mt-auto pt-6 border-t border-outline-variant/10">
        <div className="space-y-1">
          <button
            onClick={() => window.open('https://discord.gg/REPLACE_ME', '_blank', 'noopener')}
            className="flex items-center gap-3 w-full px-6 py-2 text-xs font-medium text-on-surface-variant hover:bg-surface-container-high transition-all duration-150 cursor-pointer"
          >
            <span className="material-symbols-outlined text-[18px]">
              help_outline
            </span>
            Support
            <span className="material-symbols-outlined text-[14px] ml-auto opacity-50">
              open_in_new
            </span>
          </button>
        </div>
      </div>
    </aside>
  )
}

export { Sidebar, NAV_ITEMS }
export type { SidebarProps, NavItemKey }
